import React from 'react';
import CategoryName from './JSON/CategoryName.json';
import Craft from './Craft';
import './styles.css';

export default class Material extends React.Component {
  state = {
    page: 0,
  };
  render() {
    const { page } = this.state;
    return (
      <div className="category-buttons text-center">
        {Object.entries(CategoryName).map(([id, { name }], index) => (
          <button
            key={id}
            className={`btn category-button m-1 ${page === index && 'active'}`}
            onClick={() => this.setState({ page: index })}
          >
            {name}
          </button>
        ))}
        <Craft page={page} />
      </div>
    );
  }
}
